import { render, staticRenderFns } from "./W0088V0001.vue?vue&type=template&id=d5c52fb8&scoped=true&"
import script from "./W0088V0001.vue?vue&type=script&lang=js&"
export * from "./W0088V0001.vue?vue&type=script&lang=js&"
import style0 from "./W0088V0001.vue?vue&type=style&index=0&id=d5c52fb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c52fb8",
  null
  
)

export default component.exports